/** Auth helpers: HttpOnly cookie (web) + sessionStorage Bearer (native). */

const BEARER_KEY = 'percurso:bearer';
const LEGACY_TOKEN_KEY = 'token';

export const MIN_PASSWORD_LENGTH = 12;

export function clearLegacyToken() {
  try {
    localStorage.removeItem(LEGACY_TOKEN_KEY);
  } catch (_) {
    /* ignore */
  }
}

/** Capacitor: cookies cross-origin often fail → Bearer fallback. */
export function prefersBearerFallback() {
  if (typeof window === 'undefined') return false;
  return Boolean(window.Capacitor || window.appConfig);
}

export function storeSessionToken(token) {
  clearLegacyToken();
  if (typeof sessionStorage === 'undefined') return;
  if (prefersBearerFallback() && token) {
    sessionStorage.setItem(BEARER_KEY, token);
  } else {
    sessionStorage.removeItem(BEARER_KEY);
  }
}

export function clearSessionToken() {
  clearLegacyToken();
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.removeItem(BEARER_KEY);
  }
}

export function getBearerToken() {
  if (typeof sessionStorage === 'undefined') return null;
  return sessionStorage.getItem(BEARER_KEY);
}

export function authHeaders(extra = {}) {
  const headers = { ...extra };
  const token = getBearerToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}

export function authFetch(url, options = {}) {
  const { headers, ...rest } = options;
  return fetch(url, {
    ...rest,
    credentials: 'include',
    headers: authHeaders(headers || {}),
  });
}
